import { TooltipWithBounds, defaultStyles } from "@visx/tooltip";
import React from "react";
import { colours } from "../../../constants/colours";
import type { TooltipProps } from "./types";

const ChartTooltip = ({ tooltipTop, tooltipLeft, component }: TooltipProps) => {
  const tooltipStyles = {
    ...defaultStyles,
    backgroundColor: "white",
    borderRadius: 4,
    opacity: 1,
    boxShadow: "0px 0px 6px rgba(14, 42, 54, 0.06)",
    zIndex: 1,
    border: `1px solid ${colours.surface["100"]}`,
  };
  return (
    <TooltipWithBounds
      key={Math.random()} // needed for bounds to update correctly
      left={tooltipLeft}
      top={tooltipTop}
      style={tooltipStyles}
    >
      {component}
    </TooltipWithBounds>
  );
};

export default ChartTooltip;
